<div class="container">
  <div class="close" (click)="dialogRef.close(formCompleted)">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <div class="done" *ngIf="formStep === COMMERCE_FORM_STEPS.THANKS">
    <img src="assets/icons/commerce/done.svg" alt="Success" />
  </div>
  <div class="form-header" [class.success]="this.formStep === COMMERCE_FORM_STEPS.THANKS">
    <img
      *ngIf="formStep === COMMERCE_FORM_STEPS.TYPE || formStep === COMMERCE_FORM_STEPS.THANKS"
      class="icon"
      [class.big]="formStep === COMMERCE_FORM_STEPS.THANKS"
      src="assets/icons/commerce/commerce-icon.svg"
      alt="Api Commerce TiendaCrypto"
    />
    <div class="text" *ngIf="formStep !== COMMERCE_FORM_STEPS.THANKS">
      <h1 class="title">
        {{ stepsTitles[formStep] }}
      </h1>
      <h3 class="subtitle">
        {{ stepsSubtitles[formStep] }}
      </h3>
    </div>
  </div>

  <div
    class="form-body"
    [class.column]="formStep === COMMERCE_FORM_STEPS.TYPE"
    [class.items]="formStep === COMMERCE_FORM_STEPS.INTEGRATION"
  >
    <div
      class="arrow"
      *ngIf="screenNumber === 2 && this.formStep === COMMERCE_FORM_STEPS.INTEGRATION"
      (click)="handleScreenChange('PREVIOUS')"
    >
      <img src="assets/icons/commerce/chevron-white.svg" class="icon" alt="arrow" />
    </div>

    <div
      class="arrow next"
      *ngIf="screenNumber === 1 && this.formStep === COMMERCE_FORM_STEPS.INTEGRATION"
      (click)="handleScreenChange('NEXT')"
    >
      <img src="assets/icons/commerce/chevron-white.svg" class="icon" alt="arrow" />
    </div>

    <div
      class="option"
      *ngFor="let option of getOptions(formStep)"
      (click)="handleOption(option.key)"
    >
      <div class="card" *ngIf="formStep !== COMMERCE_FORM_STEPS.FORM">
        <img
          class="option-icon"
          [src]="'assets/icons/commerce/' + option.key.toLowerCase() + '.svg'"
          alt=""
        />
        <p class="option-name">
          {{ option.name }}
        </p>
      </div>
    </div>

    <form
      class="form"
      *ngIf="formStep === COMMERCE_FORM_STEPS.FORM"
      (keyup.enter)="handleOption(COMMERCE_FORM_STEPS.FORM)"
    >
      <mat-form-field class="second" appearance="outline">
        <mat-label>Nombre de la empresa</mat-label>
        <input
          matInput
          type="text"
          [formControl]="commerceNameControl"
          placeholder="Nombre de tu negocio"
        />
        <mat-error
          *ngIf="
            (!commerceNameControl.pristine || commerceNameControl.touched) &&
            commerceNameControl.invalid
          "
        >
          {{ getErrorMessage('commerceName') }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="second" appearance="outline">
        <mat-label>Url de la tienda</mat-label>
        <input matInput type="text" [formControl]="urlControl" placeholder="Url de la tienda" />
        <mat-error *ngIf="(!urlControl.pristine || urlControl.touched) && urlControl.invalid">
          {{ getErrorMessage('url') }}
        </mat-error>
      </mat-form-field>
    </form>

    <div class="text" *ngIf="formStep === COMMERCE_FORM_STEPS.THANKS">
      <h1 class="title success">
        {{ stepsTitles[formStep] }}
      </h1>
      <h3 class="subtitle">
        {{ stepsSubtitles[formStep] }}
      </h3>
    </div>
  </div>
  <div class="form-footer" *ngIf="formStep !== COMMERCE_FORM_STEPS.TYPE">
    <button
      class="action-button"
      (click)="handleBackButton()"
      *ngIf="formStep !== COMMERCE_FORM_STEPS.THANKS"
    >
      <img src="assets/icons/commerce/chevron-right-white.svg" alt="Left Arrow" class="chevron" />
      <p class="text">Volver</p>
    </button>
    <button
      class="action-button primary"
      (click)="handleOption(COMMERCE_FORM_STEPS.FORM)"
      *ngIf="formStep === COMMERCE_FORM_STEPS.FORM"
    >
      <p class="text">Siguiente</p>
      <img src="assets/icons/commerce/chevron-right-white.svg" alt="Left Arrow" class="chevron" />
    </button>
    <button
      class="action-button primary"
      [class.success]="this.formStep === COMMERCE_FORM_STEPS.THANKS"
      (click)="dialogRef.close(formCompleted)"
      *ngIf="formStep === COMMERCE_FORM_STEPS.THANKS"
    >
      <p class="text">Aceptar</p>
    </button>
  </div>
</div>
